// extracted by mini-css-extract-plugin
export var image = "sectionTextAndImage-module--image--ef9ac";
export var reversed = "sectionTextAndImage-module--reversed--6c790";
export var section = "sectionTextAndImage-module--section--d324b";
export var text = "sectionTextAndImage-module--text--9704c";